import { Controller } from '@hotwired/stimulus';
import Leaflet from 'leaflet';

export default class extends Controller {
    connect() {
        let markers = [];

        if (this.element.dataset.markers) {
            markers = JSON.parse(this.element.dataset.markers);
        }

        let position = markers[0] ? [markers[0].latitude, markers[0].longitude] : [54.7200099,25.2673298];
        if (this.element.dataset.coords) {
            let coords = JSON.parse(this.element.dataset.coords);

            if (coords.latitude && coords.longitude) {
                position = [coords.latitude, coords.longitude];
            }
        }

        this._map = Leaflet.map(this.element, {
            center: position,
            zoom: window.screen.width <= 576 ? 11 : 13,
            scrollWheelZoom: false,
            zoomControl: false
        });


        Leaflet.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            id: 'mapbox/light-v10',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1IjoibWV0YWxiZXRhIiwiYSI6ImNsbHdhbGlhZDIwdTAzZHB2cmZ6M3Z3d3cifQ.UMf83m2bvHSgnn9aFFKcaw',
        }).addTo(this._map);

        if (markers.length) {
            markers.forEach(marker => {
                L.marker([marker.latitude, marker.longitude], {
                    icon: new L.DivIcon({
                        html: `<div class="map-marker">${marker.title}</div>`,
                        iconSize: null
                    })
                }).addTo(this._map);
            });
        }
    }
}